export default __webpack_public_path__ + "static/media/Sentiment Analysis .29d101fe.jpg";